export default __webpack_public_path__ + "static/media/abn-amro.1dc4a75a.svg";